module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/washington-800.087318d5766960b6.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/washington-800.087318d5766960b6.jpg",width: 800,height: 455}],
        src: "https://static.sniffspot.com/packs/img/washington-800.087318d5766960b6.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/washington-800.087318d5766960b6.jpg"},
        
        width: 800,
        height: 455
      }